export default "eeaba73e90066564.png"